import { CheckCircle2, Circle, FolderOpen, Server, Cpu } from "lucide-react";
import { Button } from "../ui/button";
import { MODELS } from "../layout/ModelSelector";

const STARTERS = [
  "Dame el estado actual del proyecto",
  "¿Qué pendientes y riesgos hay?",
  "Dame un resumen de seguridad",
];

function StatusRow({ icon: Icon, ok, label, detail }) {
  return (
    <div className="flex items-center gap-2 text-xs">
      {ok ? (
        <CheckCircle2 className="h-3.5 w-3.5 text-emerald-500 shrink-0" />
      ) : (
        <Circle className="h-3.5 w-3.5 text-muted-foreground shrink-0" />
      )}
      <Icon className="h-3.5 w-3.5 text-muted-foreground shrink-0" />
      <span className="text-muted-foreground">{label}:</span>
      <span className="truncate">{detail}</span>
    </div>
  );
}

export function ProjectWelcome({ project, hasServer, onManageServers, onSend, disabled }) {
  if (!project) return null;
  const modelLabel = MODELS.find((m) => m.value === project.model)?.label || project.model || "—";

  return (
    <div data-testid="project-welcome" className="w-full max-w-lg space-y-5 text-left">
      <div className="space-y-1">
        <h2 className="text-lg font-semibold">{project.name}</h2>
        {project.description && <p className="text-sm text-muted-foreground">{project.description}</p>}
      </div>

      <div className="rounded-lg border border-border p-3 space-y-1.5">
        <StatusRow
          icon={FolderOpen}
          ok={!!project.drive_folder}
          label="Documentación en Drive"
          detail={project.drive_folder || "sin carpeta"}
        />
        <StatusRow
          icon={Server}
          ok={!!hasServer}
          label="Servidor (SSH)"
          detail={hasServer ? "conectado" : "no conectado"}
        />
        <StatusRow icon={Cpu} ok label="Modelo" detail={modelLabel} />
        {onManageServers && (
          <button
            type="button"
            data-testid="welcome-servers-button"
            onClick={onManageServers}
            className="text-xs text-emerald-500 hover:underline pt-1"
          >
            {hasServer ? "Administrar servidores" : "Conectar un servidor"}
          </button>
        )}
      </div>

      <div className="space-y-1.5">
        <p className="text-xs font-medium">Qué puedes pedirme</p>
        <ul className="text-xs text-muted-foreground list-disc pl-4 space-y-0.5">
          <li>Leer y resumir la documentación del proyecto.</li>
          <li>Proponer cambios en la documentación — tú los confirmas antes de guardarse.</li>
          {hasServer ? (
            <li>Preparar comandos para el servidor — solo se ejecutan cuando tú confirmas.</li>
          ) : (
            <li>Comandos de servidor: no disponibles (este proyecto no tiene servidor conectado).</li>
          )}
        </ul>
      </div>

      <div className="space-y-1.5">
        <p className="text-xs font-medium">Para empezar</p>
        <div className="flex flex-wrap gap-2">
          {STARTERS.map((text) => (
            <Button
              key={text}
              type="button"
              size="sm"
              variant="outline"
              disabled={disabled}
              data-testid="welcome-starter-button"
              onClick={() => onSend(text)}
            >
              {text}
            </Button>
          ))}
        </div>
      </div>
    </div>
  );
}
